import variables from '@app/theme/variables'

import type { ButtonOverrideToken } from './types'

const Button: ButtonOverrideToken = {
  opacityLoading: 1,

  borderRadiusSM: variables.borderRadius,
  borderRadius: variables.borderRadius,
  borderRadiusLG: variables.borderRadius
} as const

export default Button
